import uniqBy from 'lodash/uniqBy';

const nonTechnicalUserBreadcrumbs = [
  {
    default: true,
    id: 'home',
    title: 'Home',
    href: '/#',
  },
];
const technicalUserBreadcrumbs = [
  {
    default: true,
    id: 'admin',
    title: 'Admin',
    href: '/technicalUser',
  },
  {
    default: true,
    id: 'home',
    title: 'Home',
    href: '/#',
  },
];

export const parseSet = (breadcrumbs, breadcrumb) => {
  let newBreadcrumbs = (breadcrumbs || []).filter((item) => item.default);
  newBreadcrumbs = newBreadcrumbs.concat(breadcrumb || []);
  return uniqBy(newBreadcrumbs, 'id');
};

export const parseReset = (isTechnicalUser = false) => {
  return isTechnicalUser
    ? technicalUserBreadcrumbs
    : nonTechnicalUserBreadcrumbs;
};
